export default __webpack_public_path__ + "static/media/tapir.3578ad34.png";